/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IImplant } from 'app/shared/model/implant.model';

export interface IImplantProperty {
  id?: string;
  key?: string | null;
  value?: string | null;
  group?: string | null;
  sortOrder?: number;
  active?: boolean | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  implant?: IImplant | null;
}

export const defaultValue: Readonly<IImplantProperty> = {
  active: false,
};
